export class RequestAgentCompletedTransactions{

    public   AgentID       ?:any; 
    public   TenantID      ?:string;
    public   StartDate    ?:string;
    public   EndDate      ?:string;
    public TransactionSuccess: boolean = true;
}
